import Component from '@glimmer/component';

export default class MwDummyBackground extends Component {}
